import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import { onChange } from '../../common/actions';
import { API, FLOW, PAYMODE, TOKEN } from '../../../../common/src/constant';
import CONSTANT, { CACHE, EVENTS } from '../../utils/constants';
import { handlePostData, postInWindow, openPopUpWindow } from '../../utils/formPost';
import {
  getKey,
  staticPath,
  clientMessage,
  calculateAmountPayable,
  getEncodedQs,
  find,
  equalsIgnoreCase,
  updatePayloadForValidateEMI,
  updatePayloadForTenureEMI
} from '../../utils/common';
import { EVENT, log } from '../../common/logger';
import EmiPlansList from '../emiPlans';
import MiniCart from '../miniCart';
import Loader from '../loader';
import OverlayWrap from '../OverlayWrap';
import LOCALE from '../../locale/en';
import Iframe from '../iframe';
import Renewal from '../subscription/renewal';
import { emiApi } from '../../controllers/emi';
import PaymodeOffer from '../offers/paymodeOffer';
import { RupeeSymbol } from '../rupeeSymbol';

class SC extends Component {
  hasValidationError = true;

  cvvRegex = /[^0-9]/g;

  constructor(props) {
    super(props);
    this.frame = undefined;
    const option = getKey(this, 'props.option', {});
    /* setting cvv Required as default true unless saved card response has it false */
    const cvvRequired = getKey(option, 'cardDetails.cvvRequired', true);
    const locale = clientMessage(PAYMODE.CARD.toLowerCase(), this.props.cache);
    const { url, query, method, data } = this.props.cache.getData(CACHE.API).requestPayload(API.PT);
    data.body = { ...query };
    const newStyle = `
    .ptm-card-input:focus{
      border-color:${this.props.AppStyle.themeBackgroundColor};
      caret-color:${this.props.AppStyle.themeBackgroundColor};
    }
     .ptm-card-input:focus ~ .hidden-border{
      background:${this.props.AppStyle.themeBackgroundColor};
    }
    .ptm-card-input,.card-expiry,.card-content{
      border-color:${this.props.AppStyle.borderColor};
      color:${this.props.AppStyle.bodyColor}
    }
    .ptm-check,.ptm-container:hover input ~ .ptm-check{
      border-color:${this.props.AppStyle.bodyColor};
    }
    .ptm-card-input::placeholder,.slash,.ptm-container{
       color:${this.props.AppStyle.bodyColor};
    }
    #mm:focus+span+input+p.hidden-border,#yy:focus+p.hidden-border{
      background:${this.props.AppStyle.themeBackgroundColor};
      border-color:transparent;
    }
    .ptm-change-plan{
      border-color:${this.props.AppStyle.borderColor};
    }
    .ptm-card-input{
      border-color:${this.props.AppStyle.borderColor};
      color:${this.props.AppStyle.bodyColor};
    }
    .ptm-card-input::placeholder{
      color:${this.props.AppStyle.bodyColor};
    }
    .ptm-msg-red {
      color: #ff585d;
    }
    .ptm-container input:checked ~ .ptm-check{
      background-color: ${this.props.AppStyle.themeBackgroundColor};
      border: 2px solid ${this.props.AppStyle.themeBackgroundColor};
    }`;
    this.state = {
      initializeObject: {
        type: 'INITIALIZE',
        paymode: {
          type: this.props.option.type,
          id: this.props.option.id
        },
        inputLength: getKey(this.props, 'option.cardDetails.cvvLength') || 4,
        requestPayload: {
          targetURL: `${url}?${getEncodedQs(query)}`,
          queryParams: query,
          requestData: data,
          method
        },
        style: newStyle,
        isSavedCard: true,
        messageObj: {
          label: locale.label,
          error: locale.error
        },
        // to pass cvv length to passcode html
        cvvLength: getKey(this.props, 'option.cardDetails.cvvLength', 4),
        cvvRequired,
        instanceKey: this.props.instanceKey
      },
      showEmiPlanDetails: false,
      loader: false,
      isValidPlan: true,
      iframeError: false,
      showCVV: cvvRequired
    };
    // this.label = locale.label;
    // this.error = locale.error;
  }

  componentDidUpdate(previousProps) {
    const option = getKey(this.props, 'option', null);
    const selected = getKey(this.props, 'selected', null);
    const subOption = getKey(this.props, 'selected.subOption', null);
    const previousPropsWallet = getKey(previousProps, 'wallet', null);
    const currentPropsWallet = getKey(this.props, 'wallet', null);
    const cvvRequired = getKey(this.props.selected, 'cardDetails.cvvRequired', true);
    if (
      option &&
      selected &&
      option.id === selected.id &&
      previousPropsWallet &&
      currentPropsWallet &&
      this.state.showCVV !== cvvRequired
    ) {
      this.setState({ showCVV: cvvRequired });
    }
    if (
      option &&
      selected &&
      option.id === selected.id &&
      previousPropsWallet &&
      currentPropsWallet &&
      currentPropsWallet.isUsed !== previousPropsWallet.isUsed
    ) {
      this.setState({ selectedPlan: null, showEmiPlanDetails: false });
    }
    if (selected && selected.name !== PAYMODE.EMI) {
      if (option && selected && option.id !== selected.id) {
        if (this.state.selectedPlan || this.state.showEmiPlanDetails) {
          this.setState({ selectedPlan: null, showEmiPlanDetails: false });
        }
      }
    } else if (subOption && option && subOption.id !== option.id) {
      if (this.state.selectedPlan || this.state.showEmiPlanDetails) {
        this.setState({ selectedPlan: null, showEmiPlanDetails: false });
      }
      /* if option has changed then remove the local selected plan from payment */
      if (!this.props.selectedEmiPlan && this.state.selectedPlan) {
        this.setState({ selectedPlan: null });
      }
    }
    /* if another card is selected from emi then hide the error in sc component in emi */
    if (this.props.useAnotherCard && (!this.state.isValidPlan || this.state.error)) {
      this.setState({ isValidPlan: true, error: '' });
    }
    /* if anther card is selected the mei plan set on sc is removed and set plan selected in local
      state as null */
    const emiPlans = this.props.cache.getData(CACHE.EMI_PLANS);
    if (this.state.selectedPlan && !emiPlans && !this.props.selectedEmiPlan) {
      this.setState({ selectedPlan: null });
    }
  }

  handleAfterPay = response => {
    const { actionUrl, content } = getKey(response, 'body.bankForm.redirectForm', {});
    response.body.content = content;
    response.body.callbackUrl = actionUrl;
    return response;
  };

  messageHandler = event => {
    if (
      !this.props.cache.getData(CACHE.STORE) ||
      getKey(event, 'data.calledFrom') !== 'passcode' ||
      getKey(event, 'data.instanceKey') !== this.props.instanceKey
    ) {
      return;
    }

    switch (event.data && event.data.type) {
      case CONSTANT.PAY_SUCCESS: {
        const payload = getKey(event, 'data.response', {});
        postInWindow(this.handleAfterPay(payload), this.props.cache);
        log({ eventType: EVENT.BOC_EVENT_PAY_SUCCESS });
        break;
      }
      // in case of payment fail show error
      case CONSTANT.PAY_FAIL: {
        const data = event.data.response;
        log({ eventType: EVENT.BOC_EVENT_PAY_FAIL });
        postInWindow(data, this.props.cache);
        this.props.cache.getData(CACHE.STORE).setState({ overlayValue: '' });
        if (
          getKey(data, 'body.resultInfo.resultStatus', '') === 'F' &&
          getKey(data, 'body.resultInfo.retry', '') === false
        ) {
          if (
            getKey(data, 'body.txnInfo.RESPCODE', '') === '1006' ||
            getKey(data, 'body.resultInfo.resultCode', '') === '1006'
          ) {
            this.props.onOverlayValueChange('');
            const mConfig = this.props.cache.getData(CACHE.MERCHANT_CONFIG);
            this.props.cache.getData(CACHE.STORE).setState({ sessionExpired: true });
            const notifyMerchant = getKey(mConfig, 'handler.notifyMerchant', undefined);
            if (notifyMerchant && notifyMerchant.constructor === Function) {
              notifyMerchant(CONSTANT.NOTIFY_MERCHANT_EVENTS.SESSION_EXPIRED, data);
            }
          } else {
            data.body.content = data.body.txnInfo;
            handlePostData(data, this.props.cache);
          }
        } else if (
          getKey(data, 'body.resultInfo.resultStatus') === 'F' &&
          getKey(data, 'body.resultInfo.retry') === true
        ) {
          this.props.cache.getData(CACHE.STORE).setState({
            overlayValue: CONSTANT.RETRY,
            retryMessage: getKey(data, 'body.resultInfo.resultMsg')
          });

          //  in case of reyr get fallback token from cache and set current access token
          //  and remove txn token to fetch new txn token
          if (this.props.cache.getData(CONSTANT.IS_EMISUBVENTION_ACCESS_TOKEN_FLOW)) {
            const mConfig = this.props.cache.getData(CACHE.MERCHANT_CONFIG);
            const tokenData = this.props.cache.getData(CACHE.FALLBACK_TOKEN_DATA, {
              token: getKey(mConfig, 'data.token', ''),
              tokenType: TOKEN.ACCESS
            });
            this.props.cache.setData(CACHE.TOKEN_DATA, {
              token: tokenData.token,
              tokenType: tokenData.tokenType
            });
          }
        }
        break;
      }
      case 'payerror': {
        log({ eventType: EVENT.BOC_EVENT_PAY_ERROR });
        if (this.state.payError) {
          this.setState({ showError: false, errorText: '', payError: false });
        }
        postInWindow({}, this.props.cache);
        break;
      }
      case CONSTANT.CLIENT_VALIDATION: {
        log({ eventType: EVENT.BOC_EVENT_CLIENT_VALIDATION });
        this.setState({ iframeError: true });
        postInWindow({}, this.props.cache);
        break;
      }
      case CONSTANT.SHOW_PROCESSING: {
        log({ eventType: EVENT.BOC_EVENT_SHOW_PROCESSING });
        this.props.cache.getData(CACHE.STORE).setState({ overlayValue: CONSTANT.PROCESSING });
        break;
      }

      case CONSTANT.GET_TXN_TOKEN_PAYLOAD: {
        log({ eventType: EVENT.BOC_GET_TXN_TOKEN_PAYLOAD });
        const paymodeId = getKey(event, 'data.paymode.id', null);
        const optionId = getKey(this.props, 'option.id', null);
        /*
        if the paymode id recieved from iframe is same as that of option id then only call the submit
        */
        if (paymodeId === optionId) {
          this.props.cache
            .getData(CACHE.API)
            .getAsyncPayload(API.PT, this.hasValidationError)
            .then(payload => {
              const tokenData = this.props.cache.getData(CACHE.TOKEN_DATA);
              const config = this.props.cache.getData(CACHE.MERCHANT_CONFIG);
              const orderId = this.props.cache.getData(CACHE.ORDER_ID);
              if (config && config.flow === FLOW.DEFERRED) {
                payload.data.body.orderId = orderId;
                payload.query.orderId = orderId;
              }
              const emiPlans = this.props.cache.getData(CACHE.EMI_PLANS);
              if (this.props.isEmi && !this.state.selectedPlan && !emiPlans) {
                this.setState({ isValidPlan: false });
                return;
              }

              let reqData = {
                body: {
                  type: CONSTANT.SUBMIT_WITH_TOKEN,
                  targetURL: `${payload.url}?${getEncodedQs(payload.query)}`,
                  queryParams: payload.query,
                  method: payload.method,
                  requestData: { ...payload.data },
                  paymode: { id: this.props.option.id, type: this.props.option.type },
                  paymentMode:
                    this.state.selectedPlan || this.props.isEmi
                      ? PAYMODE.EMI
                      : this.props.option.cardDetails.cardType,
                  authMode: CONSTANT.OTP,
                  selectedPaymentModeId: this.props.option.id,
                  cardInfo: `${getKey(this.props.option, 'cardDetails.cardId', '')}||`,
                  isSavedCard: true,
                  guestFlow: tokenData.tokenType !== TOKEN.TXN || false // because of use of sso token guest flow will be set to true
                }
              };

              reqData = { ...payload.data.body, ...reqData.body };

              /* if paymode is emi add emitype to request body */
              if (this.state.selectedPlan || this.props.isEmi) {
                reqData.emiType = this.props.option.cardDetails.cardType;
                reqData.isEmi = true;
                reqData.planId = emiPlans && emiPlans.pgPlanId;
              }
              reqData.inputLength = this.props.option.cardDetails.cvvLength || 4;
              this.frame && this.frame.postDataToIframe(reqData);
            })
            .catch(() => {
              // close processing screen
              this.props.onOverlayValueChange('');
            });
        }
        break;
      }
      case CONSTANT.SET_VALIDATION_STATUS: {
        this.hasValidationError = getKey(event, 'data.hasError');
        break;
      }
      case CONSTANT.OPEN_POPUP_WINDOW: {
        const paymodeId = getKey(event, 'data.paymode.id', null);
        const optionId = getKey(this.props, 'option.id', null);
        /* if the paymode id recieved from iframe is same as that of option id then only open the popup */
        if (paymodeId === optionId) {
          openPopUpWindow(this.props.cache);
          log({ eventType: EVENT.POPUP_WINDOW });
        }
        break;
      }
      case CONSTANT.HELPER_TYPE.CVV_HELPER: {
        log({ eventType: EVENT.CARD_EVENT_CVV_HELPER });
        this.props.onHelperOverlayToggle(CONSTANT.HELPER_TYPE.CVV_HELPER);
        break;
      }
      case 'INPUT_FOCUS': {
        // const defaultSelectedPaymodeOffSetTop = getKey(
        //   this.props.selected,
        //   'reference._component.componentRef.offsetTop',
        //   0
        // );
        // this.hiddenInputRef && this.hiddenInputRef.focus();
        // scrollInContentWrap(defaultSelectedPaymodeOffSetTop);
        break;
      }
      default:
        break;
    }
  };

  submit = () => {
    const payload = this.props.cache.getData(CACHE.API).requestPayload(API.PT);
    const tokenData = this.props.cache.getData(CACHE.TOKEN_DATA);

    const emiPlans = this.props.cache.getData(CACHE.EMI_PLANS);
    if (this.props.isEmi && !this.state.selectedPlan && !emiPlans) {
      this.setState({ isValidPlan: false });
      return;
    }
    // payload.data.body = { ...payload.query };
    let reqData = {
      body: {
        type: CONSTANT.SUBMIT,
        targetURL: `${payload.url}?${getEncodedQs(payload.query)}`,
        queryParams: payload.query,
        method: payload.method,
        requestData: { ...payload.data },
        paymode: { id: this.props.option.id, type: this.props.option.type },
        paymentMode:
          this.state.selectedPlan || this.props.isEmi
            ? PAYMODE.EMI
            : this.props.option.cardDetails.cardType,
        authMode: CONSTANT.OTP,
        selectedPaymentModeId: this.props.option.id,
        cardInfo: `${getKey(this.props.option, 'cardDetails.cardId', '')}||`,
        isSavedCard: true,
        guestFlow: tokenData.tokenType !== TOKEN.TXN || false // because of use of sso token guest flow will be set to true
      }
    };
    reqData = { ...payload.data.body, ...reqData.body };
    reqData.shouldPostOpenWindowEvent = this.hasValidationError;

    if (this.state.selectedPlan || this.props.isEmi) {
      reqData.emiType = this.props.option.cardDetails.cardType;
      reqData.isEmi = true;
      reqData.planId = emiPlans && emiPlans.pgPlanId;
    }

    reqData.inputLength = this.props.option.cardDetails.cvvLength || 4;
    log({
      eventType: EVENT.BOC_IFRAME_SUBMIT,
      paymentMode: reqData.paymentMode,
      payMode: this.props && this.props.option && this.props.option.type
    });
    // return 1;
    !this.hasValidationError && openPopUpWindow(this.props.cache);
    this.frame && this.frame.postDataToIframe(reqData);
  };

  handleCVVInput = e => {
    const cursorPosition = e.target.selectionStart;
    e.target.value = e.target.value.replace(this.cvvRegex, '');
    if (cursorPosition) {
      if (e.target.setSelectionRange) {
        e.target.setSelectionRange(cursorPosition, cursorPosition);
      }
    }
    this.state.cvv = e.currentTarget.value;
  };

  restrictInput = ev => {
    let digit = String.fromCharCode(ev.which);
    if (ev.key !== undefined) {
      digit = ev.key;
    }
    // any other character than digit
    if (!/^\d+$/.test(digit)) {
      if (ev.which !== 8 && ev.which !== 9 && ev.which !== 37 && ev.which !== 39) {
        ev.preventDefault();
      }
    }
  };

  onOptionSelect = option => {
    this.props.onOptionSelect(option);
  };

  areNoScEmiPlanSelected() {
    return (
      !this.state.selectedPlan && equalsIgnoreCase(getKey(this.props, 'selected.type'), CONSTANT.SC)
    );
  }

  hideEmiPlans = () => {
    this.props.cache.getData(CACHE.STORE).setState({ stopScroll: false });
    this.setState({ showEmiPlans: false });
    if (this.areNoScEmiPlanSelected()) {
      this.props.fetchPcf(this.props.option);
      this.props.applyPromoForPayMode(this.props.option);
    }
  };

  showMiniCart = plan => {
    this.props.onSelectedPlan(plan);
    this.setState({ showMiniCart: true, selectedPlan: plan });
    return null;
  };

  closeMiniCart = () => {
    this.setState({ showMiniCart: false });
  };

  getEMIPlans = option => {
    const paymentOptions = { ...this.props.cache.getData('paymentOptions') };
    /* if emi hybrid disabled set  wallet isUsed false */
    if (option.isEmiHybridDisabled && getKey(this.props, 'wallet.isUsed', false)) {
      const emiLocale = clientMessage(PAYMODE.EMI.toLowerCase(), this.props.cache);
      const wallet = { ...paymentOptions.wallet, isUsed: false };
      paymentOptions.wallet = wallet;
      const txnAmount = this.props.cache.getData(CONSTANT.TXN_AMOUNT);
      const amountPayable = calculateAmountPayable(txnAmount, paymentOptions.wallet);
      this.props.cache.setData(CACHE.PAYMENT_OPTIONS, paymentOptions);
      this.props.onWalletToggle(wallet);
      const text = getKey(
        emiLocale,
        'label.emiHybridDisabledCardText',
        'Paytm Balance and EMI cannot be used together for this payment. Please select your Emi Again'
      );
      this.props.onNotificationTextChange(text);
      this.props.onBtnTextChange(LOCALE.payButton.text + amountPayable);
      return 1;
    }
    this.setState({ loader: true, error: null });
    const paymentIntent = [];
    if (this.props.wallet && this.props.wallet.isUsed) {
      paymentIntent.push({
        mode: PAYMODE.WALLET,
        txnAmount: this.props.wallet.walletBalance
      });
    }

    const txnAmount = Number(this.props.cache.getData(CONSTANT.TXN_AMOUNT)) || 0;
    paymentIntent.push({
      banks: [option.issuingBank],
      cardHash: option.cardDetails.cardHash,
      channels: [option.channelCode],
      mode: PAYMODE.EMI,
      mode_type: option.cardDetails.cardType,
      txnAmount:
        this.props.wallet && this.props.wallet.isUsed
          ? txnAmount - this.props.wallet.walletBalance
          : txnAmount
    });
    const payload = {
      bankCode: option.issuingBank,
      cardType: option.cardDetails.cardType,
      paymentIntent
    };
    this.props.cache.setData(CACHE.PAYMENT_INTENT, paymentIntent);
    // this.setState({ paymentIntent });
    log({
      eventType: EVENTS.SC_EMI_FETCH_PLANS,
      bankCode: option.issuingBank,
      cardType: option.cardDetails.cardType
    });

    if (this.areNoScEmiPlanSelected()) {
      const emiPayMode = find(getKey(paymentOptions, 'payData.paymentModes', []), paymode =>
        equalsIgnoreCase(paymode.paymentMode, PAYMODE.EMI)
      );

      /* if it is emi subvention flow call plans api after promo has been called so that
       updated amount can be set for cart items */
      if (this.props.cache.getData(CONSTANT.IS_EMISUBVENTION_ACCESS_TOKEN_FLOW)) {
        this.props
          .applyPromoForPayMode(
            emiPayMode,
            getKey(option, 'issuingBank'),
            null,
            null,
            getKey(option, 'cardDetails.cardId')
          )
          .then(() => {
            this.fetchEmiPlansFromApi(payload);
          });
      } else {
        this.props.applyPromoForPayMode(
          emiPayMode,
          getKey(option, 'issuingBank'),
          null,
          null,
          getKey(option, 'cardDetails.cardId')
        );
        this.props.fetchPcf(emiPayMode, option.issuingBank).then(() => {
          this.fetchEmiPlansFromApi(payload);
        });
      }
    } else {
      this.fetchEmiPlansFromApi(payload);
    }
    return null;
  };

  fetchEmiPlansFromApi(payload) {
    payload = updatePayloadForTenureEMI(this.props.cache, payload);
    emiApi(this.props.cache)
      .getEmiPlans(payload)
      .then(data => {
        this.props.cache.setData(CACHE.PLAN_DETAILS, data);
        this.props.cache.getData(CACHE.STORE).setState({ stopScroll: true });
        this.setState({ showEmiPlans: true, loader: false });
      })
      .catch(err => {
        this.setState({ loader: false, error: err.message });
        log({
          eventType: EVENTS.SC_EMI_FETCH_PLANS_ERROR,
          error: err
        });
      });
  }

  selectEmiPlan = plan => {
    this.setState({ loader: true });
    const itemHash = {};
    this.props.onSelectedPlan(plan);
    const planDetails = this.props.cache.getData(CACHE.PLAN_DETAILS);
    const paymentIntent = this.props.cache.getData(CACHE.PAYMENT_INTENT);

    getKey(planDetails, 'cart.cart_items', []).map(item => {
      const offerId = getKey(item, `emi_offers.${plan.planId}.offerId`);
      itemHash[item.item_id] = offerId ? { offer_id: offerId } : {};
      return item;
    });

    const requestPayload = {
      plan_id: plan.planId,
      pgPlanId: plan.pgPlanId,
      item_map: itemHash,
      paymentIntent,
      bankCode: planDetails.bankCode,
      planId: plan.planId // adding a duplicate since in another place this needs to be used and camel case is not being allowed by eslint
    };

    log({
      eventType: EVENTS.SC_EMI_APPLY_PLAN,
      plan_id: plan.planId,
      item_map: itemHash
    });

    const isEmiSubventionFlow = this.props.cache.getData(
      CONSTANT.IS_EMISUBVENTION_ACCESS_TOKEN_FLOW
    );
    if (isEmiSubventionFlow) {
      this.getCacheCardTokenForSavedCard()
        .then(resp => {
          this.applyEMIFunction(requestPayload, plan, resp);
        })
        .catch(err => {
          const errorMsg = getKey(err, 'ErrorMsg', CONSTANT.GENERIC_ERROR);
          this.setState({ loader: false, error: errorMsg });
        });
    } else {
      this.applyEMIFunction(requestPayload, plan);
    }

    return null;
  };

  applyEMIFunction = (requestPayload, plan, cacheCardToken = null) => {
    requestPayload = updatePayloadForValidateEMI(
      this.props.cache,
      plan,
      requestPayload,
      cacheCardToken
    );
    const gratifications = getKey(plan, 'gratifications', []);
    const isStandardEmi = !gratifications.length;
    requestPayload = updatePayloadForValidateEMI(
      this.props.cache,
      plan,
      requestPayload,
      this.props.cache.getData(CONSTANT.CACHE_CARD_TOKEN)
    );
    /* if plan selected is not subvented emi call default flow function in case of validate emi that
     is  not to make validate emi api call */
    emiApi(this.props.cache, isStandardEmi)
      .applyEmi(requestPayload)
      .then(data => {
        const { apiResponse, fallBackAmount, txnAmount } = data;
        if (apiResponse) {
          const { emiSubventionToken } = apiResponse;
          this.props.cache.setData(CONSTANT.EMISUBVENTION_TOKEN, emiSubventionToken);
        }
        this.setState({ loader: false });
        if (apiResponse) {
          this.props.cache.setData(CACHE.PLAN_DETAILS, apiResponse);
        }
        /* set existing amount in fallback amount so that on payment mode change amount is restored */
        const paymentOptions = this.props.cache.getData('paymentOptions');
        const walletObj = { ...paymentOptions.wallet };
        this.props.cache.setData(CONSTANT.FALLBACK_TXN_AMOUNT, fallBackAmount);
        this.props.cache.setData(CONSTANT.TXN_AMOUNT, txnAmount);
        this.amountPayable = calculateAmountPayable(txnAmount, walletObj);
        const payAmountText = LOCALE.payButton.text + this.amountPayable;
        this.props.onBtnTextChange(payAmountText);
        this.props.onSelectedPlan(plan);
        this.setState({
          showEmiPlans: false,
          showEmiPlanDetails: true,
          selectedPlan: plan,
          isValidPlan: true
        });
        this.props.cache.getData(CACHE.STORE).setState({ stopScroll: false });
        this.props.cache.setData(CACHE.EMI_PLANS, requestPayload);
      })
      .catch(err => {
        this.setState({ loader: false });
        log({
          eventType: EVENTS.SC_EMI_APPLY_PLAN_ERROR,
          error: err
        });
        this.props.onSelectedPlan(null);
        const locale = clientMessage(PAYMODE.EMI.toLowerCase(), this.props.cache);
        this.setState({
          loader: false,
          bankError: true,
          errorHeading: locale.error.emiPlanError,
          errorSubText: err.message || locale.error.emiPlanSubtext
        });
      });
  };

  setEmiPlan = plan => {
    this.props.onSelectedPlan(plan);
    this.setState({ selectedPlan: plan });
  };

  getCacheCardTokenForSavedCard = () => {
    const mid = this.props.cache.getData(CACHE.MID);
    const savedCardId = getKey(this, 'props.option.cardDetails.cardId', '');
    const tokenData = this.props.cache.getData(CACHE.TOKEN_DATA);
    const token = getKey(tokenData, 'token', '');
    const mConfig = this.props.cache.getData(CACHE.MERCHANT_CONFIG);
    const referenceId = getKey(mConfig, 'emiSubvention.referenceId', '');
    const payload = {
      SAVED_CARD_ID: savedCardId,
      MID: mid,
      ACCESS_TOKEN: token,
      CUST_ID: getKey(mConfig, 'emiSubvention.customerId', null)
    };
    /* since the content type is application form encoded middleware wont run on it hence the url
    wont have query params mid and reference id so sending it as another object */
    const urlQueryParams = {
      mid,
      referenceId
    };
    return new Promise((resolve, reject) => {
      this.props.cache
        .getData(CACHE.API)
        .getCacheCardToken(payload, urlQueryParams)
        .then(resp => {
          const status = getKey(resp, 'STATUS', 'FAILURE');
          if (status === 'SUCCESS') {
            return resolve(getKey(resp, 'TOKEN', null));
          }
          const errorMsg = getKey(resp, 'ErrorMsg', '');
          this.setState({ loader: false, error: errorMsg });
          return resolve(getKey(resp, 'TOKEN', null));
        })
        .catch(err => {
          return reject(err);
        });
    });
  };

  hideShowError = () => {
    this.setState({ bankError: false, errorHeading: '', errorSubText: '' });
  };

  render(
    {
      option,
      instanceKey,
      cache,
      selected,
      isDisplay,
      isActive,
      isEmi = false,
      offers,
      isPromoAvailable
    },
    {
      showEmiPlans,
      showMiniCart,
      selectedPlan,
      showEmiPlanDetails,
      initializeObject,
      loader,
      isValidPlan,
      iframeError,
      showCVV,
      error,
      bankError,
      errorSubText,
      errorHeading
    }
  ) {
    const emiType = {
      LOW_COST: 'Low Cost EMI Available',
      ZERO_COST: 'Zero Cost EMI Available'
    };
    const planDetails = cache.getData(CACHE.PLAN_DETAILS);
    let gratification = getKey(selectedPlan, 'gratifications', null);
    const scOffer = isPromoAvailable
      ? option && equalsIgnoreCase(getKey(selected, 'type'), CONSTANT.SC) && isActive
        ? getKey(offers, selectedPlan ? CONSTANT.EMI : CONSTANT.SC)
        : getKey(option, 'paymentOfferDetails')
      : null;
    if (gratification) {
      gratification = gratification[0];
    }

    const isEmiSubventionFlow = cache.getData(CONSTANT.IS_EMISUBVENTION_ACCESS_TOKEN_FLOW);
    const miniCart = cache.getData(CONSTANT.SUBVENTION_MINI_CART_OBJ);

    const locale = clientMessage(PAYMODE.EMI.toLowerCase(), cache);
    return isDisplay ? (
      <div
        className={`ptm-sc-main ${isEmi ? 'ptm-emi-sc' : ''} ptm-test-checkout-sc-${option.id}`}
        ref={componentRef => {
          this.componentRef = componentRef;
        }}
      >
        <div class={`ptm-pay-method ptm-w100-ib ptm-checkout-sc-${option.id}`} id="ptm-checkout-sc">
          <div class={`ptm-sc sc-wrap-test`}>
            <div
              class={`ptm-radio-wrap`}
              onClick={() => {
                this.onOptionSelect(option);
              }}
            >
              <label class="ptm-lbl" for={`sc-radio-${option.id}`}>
                <input
                  type="radio"
                  name={`verify-sc${instanceKey}`}
                  className={`ptm-margin0`}
                  id={`sc-radio-${option.id}`}
                  checked={isActive}
                />
                <span class="ptm-checkmark" />
                <div class={`ptm-pay-method-cont`}>
                  <p class={`ptm-paymode-name `}>
                    {option.displayName}
                    <span className={`ptm-card-type-img ${option.cardScheme}`} />
                  </p>
                  <p class={`ptm-small-txt`}>
                    {option.scType} XXXX {option.lastFour}
                  </p>
                </div>
              </label>
            </div>
          </div>
          {/* adding a check for show cvv so  that for maestro the cvv is not visible */}
          {option && isActive && (
            <div>
              <Iframe
                ref={r => (this.frame = r)}
                classname={`ptm-sc-iframe ${iframeError ? 'error' : ''}
                 ${showCVV ? 'show-cvv-iframe' : 'hide-cvv-iframe'}`}
                option={option}
                postMessageHandler={this.messageHandler}
                src={`${staticPath()}/assets/iframes/passcode.html`}
                {...{ initializeObject }}
              />
              {option.isEmiAvailable && !option.subventionType && (
                <div
                  className={`ptm-emi-avl ptm-small-txt-link ptm-pos-r`}
                  onClick={() => {
                    this.getEMIPlans(option);
                  }}
                >
                  <div className={`ptm-txt ptm-primary`}>EMI Available</div>
                  {loader && (
                    <div className={`ptm-loader-wrap`}>
                      <Loader />
                    </div>
                  )}
                  {!isValidPlan && (
                    <p class="ptm-small-txt ptm-msg-red ptm-selectplan-error">
                      Please select EMI Plan
                    </p>
                  )}
                </div>
              )}
              {option.subventionType && (
                <div className={`ptm-emi-avl ptm-small-txt-link ptm-pos-r`}>
                  <div
                    className={`ptm-txt`}
                    onClick={() => {
                      this.getEMIPlans(option);
                    }}
                  >
                    {emiType[option.subventionType]}
                  </div>
                  {loader && (
                    <div className={`ptm-loader-wrap`}>
                      <Loader />
                    </div>
                  )}
                  {!isValidPlan && <p class="ptm-small-txt ptm-msg-red">Please select EMI Plan</p>}
                </div>
              )}
              {showEmiPlanDetails && selectedPlan && (
                <div className={`ptm-change-plan ptm-body-bg`} id="planDetails">
                  <p className={`ptm-emi-cal`} id="emiPlans">
                    {`EMI of`} <RupeeSymbol />{' '}
                    {`${selectedPlan.emi} for ${selectedPlan.interval} months @ ${selectedPlan.rate}% p.a.`}
                  </p>
                  <h6 className={`ptm-total-amount`} id="price">
                    {`Total`} <RupeeSymbol /> {`${selectedPlan.effectivePrice}`}
                  </h6>
                  <p
                    className="ptm-small-txt-link"
                    id="changePlan"
                    onClick={() => {
                      this.getEMIPlans(option);
                    }}
                  >
                    Change Plan
                  </p>
                  {gratification && (
                    <div className={`ptm-applied-offer`}>
                      <p className={`ptm-applied-para`}>
                        EMI offer of <RupeeSymbol /> {gratification.value} {gratification.label}{' '}
                        successfully applied
                      </p>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
          {scOffer && <PaymodeOffer offer={scOffer} applied={isActive} />}
          {error && <p className={`ptm-small-txt ptm-msg-red ptm-sc-error`}> {error} </p>}
          {option && isActive && <Renewal />}
          {showEmiPlans && (
            <div className={`ptm-emi-overlay`}>
              <OverlayWrap>
                <EmiPlansList
                  planDetails={planDetails}
                  hideEmiPlans={this.hideEmiPlans}
                  setEmiPlan={this.setEmiPlan}
                  showMiniCart={this.showMiniCart}
                  selectEmiPlan={this.selectEmiPlan}
                  miniCart={miniCart}
                />
              </OverlayWrap>
              {loader && (
                <div className={`ptm-bank-loader-wrap`}>
                  <div className={`ptm-inn-load-wrap ptm-centralized ptm-pos-a`}>
                    <Loader />
                  </div>
                </div>
              )}
            </div>
          )}
          {/* if cart exists ie deferred flow or emiSubventionFlow key is true and mini cart object
           is passed in config show mini cart */}
          {showMiniCart && (planDetails.cart || (isEmiSubventionFlow && miniCart)) && selectedPlan && (
            <div className={`ptm-emi-overlay`}>
              <OverlayWrap>
                <MiniCart
                  cart={planDetails.cart}
                  selectedPlan={selectedPlan}
                  isEmiSubventionFlow={isEmiSubventionFlow}
                  closeMiniCart={this.closeMiniCart}
                  miniCart={miniCart}
                />
              </OverlayWrap>
            </div>
          )}

          {bankError && (
            <div className={`ptm-emi-overlay-bank-error`}>
              <div className={`ptm-modal-wrapper ptm-body-bg`}>
                <div className={`ptm-excl-box ptm-pos-r`}>
                  <span className={`ptm-centralized ptm-pos-a`}>!</span>
                </div>
                <h2 className={`ptm-body-color`}>{errorHeading}</h2>
                <p className={`ptm-body-color`}>{errorSubText}</p>
                <button onClick={this.hideShowError}>{locale.error.errorBtn}</button>
              </div>
            </div>
          )}
        </div>
        <p className="ptm-global-bottom-border" />
      </div>
    ) : null;
  }
}

export default connect(
  'selected, wallet, selectedEmiPlan, AppStyle, cache, instanceKey',
  onChange
)(SC);



// WEBPACK FOOTER //
// ./components/sc/index.js